import { connect } from 'react-redux';
import { getActivitiesByObjectiveId } from '@/core/slices/activities';
import { getRequirements } from '@/core/slices/requirements';
import { fetchObjectivesByVersionId } from '@/core/slices/objectives';
import { fetchAllFocuses } from '@/core/slices/focuses';
import {
  objectives,
  activities,
  requirements,
  focuses,
  currentVersion,
  readOnlyMode,
  currentFulfillmentVersion,
  selectedYear,
  scopeName,
  enterpriseName,
  currentPlanId,
  currentBusinessUnit,
  planRequirementDecisions,
} from '../../../../../../core/selectors';
import { RootState } from '@/core/types/state';
import {
  addFocusDefinitionApproval,
  addPlanDefinitionApproval,
  getFocusDefinitionApprovals,
  getPlanDefinitionApproval,
  fetchPlanRequirementDecisions,
} from '@/core/slices/plans';
import ApprovalDefinitions from '../../../../components/AnnualPlanning/FirstTerm/ApprovalDefinitions';

const ConnectedApprovalDefinitions = connect(
  (state: RootState) => ({
    objectives: objectives(state),
    activities: activities(state),
    requirements: requirements(state),
    focuses: focuses(state),
    currentVersion: currentVersion(state),
    currentFulfillmentVersion: currentFulfillmentVersion(state),
    currentPlanId: currentPlanId(state),
    readOnlyMode: readOnlyMode(state),
    selectedYear: selectedYear(state),
    scopeName: scopeName(state),
    enterpriseName: enterpriseName(state),
    currentBusinessUnit: currentBusinessUnit(state),
    planRequirementDecisions: planRequirementDecisions(state),
  }),
  {
    fetchObjectivesByVersionId,
    getActivitiesByObjectiveId,
    getRequirements,
    fetchAllFocuses,
    addFocusDefinitionApproval,
    addPlanDefinitionApproval,
    getFocusDefinitionApprovals,
    getPlanDefinitionApproval,
    fetchPlanRequirementDecisions,
  },
)(ApprovalDefinitions);

export default ConnectedApprovalDefinitions;
